import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { FiUploadCloud } from "react-icons/fi";
import { notifyError, notifySuccess } from "../../utils/toast";

const ApkUploader = ({
  setFileUrl,
  fileUrl,
  folder,
  name_merge,
  onFileUpload,
  maxSizeMB = 100, // default 30MB max size
}) => {
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  const authToken = adminInfo?.token;

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: "application/vnd.android.package-archive",
    multiple: false,
    maxSize: maxSizeMB * 1024 * 1024, // e.g., 30 MB
    onDrop: (acceptedFiles) => {
      setFiles(acceptedFiles);
    },
  });

  useEffect(() => {
    if (fileRejections.length > 0) {
      setError("File not accepted due to size or type.");
      fileRejections.forEach(({ file, errors }) => {
        errors.forEach((error) => {
          if (error.code === "file-too-large") {
            setError(`File exceeds the maximum size of ${maxSizeMB}MB.`);
          }
        });
      });
    }
    if (files.length > 0) {
      setLoading(true);
      setError(""); // Clear any existing error messages
      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("folderName", folder);
      formData.append("name_merge", name_merge);

      axios({
        url:
          process.env.REACT_APP_API_BASE_URL +
          `/upload/upload-single/${name_merge}/${folder}`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
        data: formData,
      })
        .then((res) => {
          notifySuccess("APK uploaded successfully!");
          setLoading(false);
          if (res?.data?.image_path) {
            setFileUrl(res.data.image_path);
          //  onFileUpload?.(res.data.image_path);
          }
        })
        .catch((err) => {
          console.error("Upload error", err);
          setLoading(false);
          notifyError(err.message || "Upload failed");
        });
    }
  }, [files, fileRejections, authToken, folder, name_merge, setFileUrl, onFileUpload,maxSizeMB]);

  return (
    <div className="w-full text-center">
      {loading && <p>Uploading...</p>}
      {!fileUrl && files.length === 0 && (
        <div
          className="border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer px-6 pt-5 pb-6"
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <span className="mx-auto flex justify-center">
            <FiUploadCloud className="text-3xl text-green-500" />
          </span>
          <p className="text-sm mt-2">Drag and drop your APK file here</p>
          <em className="text-xs text-gray-400">
            Accepted format: .apk, Max size: {maxSizeMB}MB
          </em>
        </div>
      )}
      {fileUrl && (
        <div className="mt-2 text-green-600 text-sm">
          File uploaded: <a href={fileUrl} target="_blank" rel="noreferrer" className="underline">{fileUrl}</a>
        </div>
      )}
      {error && <p className="text-red-500">{error}</p>}
    </div>
  );
};

export default ApkUploader;
